export default "__VITE_ASSET__NtTFgz36__"